import { render } from "./MajorTable.vue?vue&type=template&id=6a2695c6&scoped=true"
import script from "./MajorTable.vue?vue&type=script&lang=js"
export * from "./MajorTable.vue?vue&type=script&lang=js"

import "./MajorTable.vue?vue&type=style&index=0&id=6a2695c6&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2695c6"]])

export default __exports__